import {forwardRef} from "react";

const BasicDateInput = forwardRef(function BasicDateInput(
    {
        className = "",
        defaultValue,
        label,
        onChange,
        onBlur,
    },
    ref
) {
    const classes = `${className} "w-full py-1.5 px-4 bg-gray-700 rounded text-gray-200 border border-gray-600 text-lg focus:border-red-500 hover:border-red-500"`;
    const inputElement =
        <input
            type="date"
            defaultValue={defaultValue}
            className={classes}
            onChange={onChange}
            onBlur={onBlur}
            ref={ref}
        />;
    if (label) {
        return (
            <label>
                <div className="mb-0.5 font-bold text-lg">{label}</div>
                {inputElement}
            </label>
        )
    }
    return inputElement;
});

export default BasicDateInput;